<div class='InboxListing'>
  <div class='InboxListing-header d-flex flex-row mb-3 mt-3'>
    <div
      class='InboxListing-header-title flex-grow-1 d-flex flex-row align-items-center'>
      <div class='flex-grow-1'>
        <h4 class='title__page'>Inbox</h4>
      </div>
    </div>
    <div class='InboxListing-header--filter' *ngIf="tableFilters.length">
      <app-select (selection)='customFilterSelection($event)' [items]='tableFilters[0].items'
                  [label]='tableFilters[0].label'></app-select>
    </div>
  </div>
  <div class='InboxListing-body'>
    <app-table
      #tableComponent
      (data)='onData($event)'
      [columns]='tableColumns'
      [dataSourceParams]='tableDataSourceParams'
      [dataSource]='tableDataSource'
      [filterGroups]='tableFilterGroups'
      [massiveActions]='tableMassiveActions'
      [rowClass]='getRowClass'
      [selectable]='false'
      [useRouteNavigation]='useTableRouteNavigation'>
      <ng-template [appTableMobileRow] let-currentUser='currentUser' let-row='row'>
        <app-list-messages-mobile-row [currentUser]='currentUser' [row]='row'></app-list-messages-mobile-row>
      </ng-template>
    </app-table>
  </div>
</div>
